export const ROUTER_MANAGE_EDIT = 'routerManageEdit'

export const FORM_ITEM = {
    name: '',
    home_page: '',
    remark: '',
    app_token: '',
}

export const FORM_ITEM_ROUTER = {
    parent_name: '',
    parent_key:'',
    parent_id:null,
    name: '',
    auth_key: '',
    pinyin: '',
    icon: '',
    route_type: '',
    path: '',
    red_dot_token: '',
    pb_workspace_id: '',
    pb_report_id: '',
    is_public: false,
    is_formal: false,
    is_team_leader: false
}
